import { createAction } from '@reduxjs/toolkit';

export const shopSelectorActions = {
  // handled in navigate middleware to generate path based on current URL
  navigateToShop: createAction<{ shopId: number }>('ShopSelector/navigateToShop'),
};
